import { HEALTH_WEEK_PACKAGES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data: HealthWeekPackages;
    error?: string;
}

export interface HealthWeekPackages {
    docid?: string;
    packages: Package[];
    created_at?: string;
    updated_at?: string;
}

export interface Package {
    name: string;
    includedTests: number;
    sellingPrice: number;
    totalPrice: number;
    discount: number;
    overview: string;
    tests: Test[];
    includedParameters?: number;
}

export interface Test {
    id: string;
    name: string;
}

export default (): Promise<Response> =>
    fetchWithRefresh(HEALTH_WEEK_PACKAGES).then((res) => res.json());
